// @icons:begin — generated from libs/controls/src/lib/atomic/icon/icon.types.ts by tools/icons/icons.mjs; do not edit by hand. Run `npm run icons:sync`.

export const ICONS = {
  //App Toolbar
  HOME: 'Home',
  APPS: 'Apps',
  ACCOUNT: 'Account_Circle',
  AKSIA_LOGO: '@custom-icon-aksia_logo',

  //Apps
  ADMIN: 'Admin_Panel_Settings',
  AI: '@custom-icon-ai',
  DATA: 'Database',
  MAX: 'Work',
  REPORTS: 'Lab_Profile',
  WORKFLOWS: 'Rebase',
  OSTRAKO: '@custom-icon-ostrako',

  //App Tools
  EMAIL_DATA_EXTRACTOR: '@custom-icon-email_data_extractor',
  ADMIN_CLIENT: 'Identity_Platform',
  ADMIN_ARTICLES: 'Article',
  ADMIN_DISCLAIMERS: 'Format_List_Bulleted',
  ADMIN_SCREENERS: 'Table_View',
  ADMIN_ROLES: 'Domino_Mask',
  ADMIN_APPLICATIONS: 'View_Apps',
  ADMIN_COUNTRY_BLOCKS: '@custom-icon-flag_not',

  //Entities
  COMPANY: 'Attach_Money',
  PROGRAM: 'Graph_4',
  FUND: 'Show_Chart',
  HOLDING: 'Confirmation_Number',
  PORTFOLIO: 'Folder_Open',
  CONTACTS: 'Contacts',

  //Input Types
  INPUT_CHECK: 'Toggle_Off',
  INPUT_DATE: 'Calendar_Month',
  INPUT_DROPDOWN: 'Dropdown',
  INPUT_MULTI_DROPDOWN: 'Featured_Play_List',
  INPUT_NUMBER: '123',
  INPUT_TEXT: 'Abc',

  //Actions
  ADD: 'Add',
  ALL_INBOX: 'All_Inbox',
  ALL_INCLUSIVE: 'All_Inclusive',
  APARTMENT: 'Apartment',
  ARROW_UP: 'Arrow_Upward',
  ARROW_DOWN: 'Arrow_Downward',
  ARROW_FORWARF: 'Arrow_Forward',
  ATTACH_FILE: 'Attach_File',
  AUTORENEW: 'Autorenew',
  BAR_CHART: 'Bar_Chart',
  BRIGHTNESS: 'Brightness_Empty',
  CALENDAR: 'Calendar_Month',
  CALENDAR_TODAY: 'Calendar_Today',
  CALL: 'Call',
  CHECK: 'Check',
  CHECK_CIRCLE: 'Check_Circle',
  CHECKLIST: 'Checklist',
  CHEVRON_DOWN: 'Keyboard_Arrow_Down',
  CHEVRON_UP: 'Keyboard_Arrow_Up',
  CHEVRON_LEFT: 'Chevron_Left',
  CHEVRON_RIGHT: 'Chevron_Right',
  CLOSE: 'Close',
  CLOSE_SMALL: 'Close_Small',
  CLOUD: 'Cloud',
  CLOUD_OFF: 'Cloud_Off',
  COLLAPSE: 'Collapse_Content',
  COLUMN: 'View_Column',
  CONTENT_COPY: 'Content_Copy',
  CSV: 'Csv',
  DATA_ARRAY: 'Data_Array',
  DATA_OBJECT: 'Data_Object',
  DATA_TABLE: 'Data_Table',
  DATASET_LINKED: 'Dataset_Linked',
  DELETE: 'Delete',
  DEPLOYED_CODE: 'Deployed_Code',
  DEPLOYED_CODE_UPDATE: 'Deployed_Code_Update',
  DISABLED: 'Disabled_By_Default',
  DOWNLOAD: 'Download',
  DRAG_INDICATOR: 'Drag_Indicator',
  EAST: 'East',
  EDIT: 'Edit',
  ERROR: 'Error',
  EXCEL: '@custom-icon-excel',
  EXPAND: 'Expand_Content',
  FAX: 'Fax',
  FACT_CHECK: 'Fact_Check',
  FILE_COPY: 'File_Copy',
  FILE_JSON: 'File_Json',
  FILE_SAVE: 'File_Save',
  FILE_SAVE_OFF: 'File_Save_Off',
  FILTER: 'Filter_Alt',
  FILTER_LIST: 'Filter_List',
  HELP: 'Help',
  INFO: 'Info',
  INSTANT_MIX: 'Instant_Mix',
  KEY: 'Key',
  LINK: 'North_East',
  LINKED: 'Link',
  LIST: 'List',
  LIST_ALT: 'List_Alt',
  LISTS: 'Lists',
  LOCATION: 'Location_On',
  LOCK: 'Lock',
  LOGO_DEV: 'Logo_Dev',
  MANAGE_ACCOUNTS: 'Manage_Accounts',
  MENU: 'Menu',
  MORE_HORIZ: 'More_Horiz',
  MORE_VERT: 'More_Vert',
  NOTIFICATIONS: 'Notifications',
  OPEN_IN_NEW: 'Open_In_New',
  PASSWORD: 'Password',
  PDF: 'Picture_As_Pdf',
  PERSON: 'Person',
  PERSON_ADD: 'Person_Add',
  PIN: 'Keep',
  PLAY_ARROW: 'Play_Arrow',
  PLAY_DISABLED: 'Play_Disabled',
  PLAYLIST_ADD_CHECK: 'Playlist_Add_Check',
  PROGRESS: 'Progress_Activity',
  RADIO_CHECKED: 'Radio_Button_Checked',
  RADIO_UNCHECKED: 'Radio_Button_Unchecked',
  REMOVE: 'Remove',
  REPLAY: 'Replay',
  RULE_SETTINGS: 'Rule_Settings',
  SAVE: 'Save',
  SEARCH: 'Search',
  SETTINGS: 'Settings',
  STAR: 'Kid_Star',
  STICKY_NOTE: 'Sticky_Note_2',
  STORAGE: 'Storage',
  SYNC: 'Sync',
  TABLE: 'Table',
  TABLE_VIEW: 'Table_View',
  TEXTFIELD: 'Text_Fields_Alt',
  THUMB_UP: 'Thumb_Up',
  THUMB_DOWN: 'Thumb_Down',
  UNLINKED: 'Link_Off',
  UNPIN: 'Keep_Off',
  UPLOAD: 'Upload',
  VIEW_COLUMN: '@custom-icon-manage-columns',
  VIEW_COMPACT_ALT: 'View_Compact_Alt',
  VISIBILITY: 'Visibility',
  WARNING: 'Warning',
  ZOOM_IN: 'Zoom_In',
  ZOOM_OUT: 'Zoom_Out',

  //Asset Classes

  AA: '@custom-icon-asset_class_aa',
  CI: '@custom-icon-asset_class_ci',
  FF: '@custom-icon-asset_class_ff',
  LA: '@custom-icon-asset_class_la',
  LC: '@custom-icon-asset_class_lc',
  LE: '@custom-icon-asset_class_le',
  LO: '@custom-icon-asset_class_lo',
  MC: '@custom-icon-asset_class_mc',
  PC: '@custom-icon-asset_class_pc',
  PE: '@custom-icon-asset_class_pe',
  RA: '@custom-icon-asset_class_ra',
  SE: '@custom-icon-asset_class_se',
  HF: '@custom-icon-asset_class_hf',
} as const;

export type IconType = (typeof ICONS)[keyof typeof ICONS];
// @icons:end
